import { render, staticRenderFns } from "./TagFilter.vue?vue&type=template&id=82c1b306&scoped=true&"
import script from "./TagFilter.vue?vue&type=script&lang=js&"
export * from "./TagFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c1b306",
  null
  
)

export default component.exports